<template>
  <section>
    <div class="my-3">
      <v-layout row wrap justify-space-between>
        <v-flex xs3 fluid align-center justyfy-center>
          <v-dialog persistent v-model="modalWindow" max-width="900px">
            <v-btn color="primary" dark slot="activator" class="mb-2" v-if="isWriteAvailable">Add type of sponsor</v-btn>
            <form-sponsors-types
              :isCreate="isNewType"
              v-if='showForm'
              @saveSponsorsType="saveSponsorsType"
              @close="close"
              :form="typeForm"
            />
          </v-dialog>
        </v-flex>
      </v-layout>
      <table-sponsor-type/>
    </div>
  </section>
</template>
<script>
import FormSponsorsTypes from './FormSponsorsTypes.vue'
import TableSponsorType from './TableSponsorType.vue'
import { mapActions } from 'vuex'
import lodash from 'lodash'
import mixins from '@/utils/mixins'

export default {
  name: 'SponsorTypes',
  mixins: [mixins.isWriteAvailable],
  components: {
    FormSponsorsTypes,
    TableSponsorType
  },
  data () {
    return {
      typeForm: {},
      defaultTypeForm: {},
      modalWindow: false,
      isNewType: true,
      showForm: false,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'sponsors:write'
    }
  },
  created () {
    this.$bus.$on('editSponsorType', (item) => {
      this.typeForm = lodash.cloneDeep(item)
      this.typeForm.fontColor = {hex: item.fontColor}
      this.isNewType = false
      this.toggleModal('modalWindow')
    }),
    this.defaultTypeForm = lodash.cloneDeep({
        title: '',
        fontFamily: '"Montserrat", sans-serif',
        fontColor: { hex: '#000000' },
        fontSize: 16,
        fontWeight: 400,
        imageEffect: 'None'
      }),
      this.typeForm = lodash.cloneDeep(this.defaultTypeForm)
  },
  watch: {
    modalWindow (val) {
      if (val) {
        this.showForm = true
      }
    }
  },
  methods: {
    ...mapActions([
      'createSponsorType',
      'removeSponsorType',
      'editSponsorType'
    ]),
    toggleModal (varModal) {
      this[varModal] = !this[varModal]
    },
    async saveSponsorsType (form) {
      let payload = lodash.cloneDeep(form)
      payload.fontColor = form.fontColor.hex
      if (this.isNewType) {
        try {
          await this.createSponsorType(payload)
          this.close()
        }catch (err) {
          throw err
        }
      } else {
        try {
          await this.editSponsorType(payload)
          this.close()
        }catch (err) {
          throw err
        }
      }
    },
    close () {
      this.toggleModal('modalWindow')
      this.typeForm = lodash.cloneDeep(this.defaultTypeForm)
      this.isNewType = true
      this.showForm = false
      this.$bus.$emit('reloadData')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .vc-chrome {
  position: absolute;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/SponsorsTypes/index.vue